import type { FaireProductEntity } from "../../entity_types/product";

export const p_j6snhz9tk5: FaireProductEntity = {
  token: "p_j6snhz9tk5",
  type: "product",
  name: "Frutta Martorana – Sicilian Marzipan Fruit Assortment (150g)",
  brandToken: "b_6cjsp5frk5",
  brandName: "Alto Imports Company",
  imageUrl:
    "https://cdn.faire.com/fastly/4536280d0ab4d64108c9ac01ff8098d7a3f7e2e8cbc7080e21d1817028783695.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5d592ac4248b536ac91323c2f70243fe2d1e3a943ea3c8227e08af1f664940f7.png",
  ],
  priceDollars: 8.73,
  description:
    "Frutta Martorana is one of Sicily’s most iconic artisanal sweets — beautifully hand-crafted marzipan fruits made with almonds, sugar, and honey. Each piece is carefully molded and painted to resemble real fruit, creating an elegant, gourmet treat perfect for gifting, holidays, coffee bars, bakeries, and specialty retailers.\n\nThis 150g box contains an assortment of colorful marzipan fruit shapes, made in Belpasso (Catania, Sicily) using traditional recipes. The texture is soft and rich, with authentic almond flavor and a hint of honey.\n\nIdeal for: holiday gift boxes, gourmet shops, Italian markets, corporate gifts, bakery counters, display merchandising, and tourist specialty stores.\n\nAuthentic Sicilian marzipan fruit, hand-crafted\nMade with real almonds, sugar & honey\nBeautiful presentation box for gifting\nLong shelf life: 12 months\nProduct of Italy\nPerfect for premium holiday or year-round displays\nFratelli Sicilia",
  tags: [],
  msrpDollars: 17.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:46.322Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
